#!/usr/bin/env node

import { runCli } from '~/cli';

runCli();
